import React, { useEffect, useRef, useState } from "react";
import "./BigCalendar.css";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import enUS from "date-fns/locale/en-US";
import "react-big-calendar/lib/css/react-big-calendar.css";
import EventCreationModal from "../../HomeComponents/EventCreationModal";
import ShowMoreEventsModal from "../../HomeComponents/ShowMoreEventsModal";
import axios from "axios";
import { base_url } from "../../../utils/AxiosConfig";
import dayjs from "dayjs";
const locales = { "en-US": enUS };
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});
// ─── Custom Toolbar ───────────────────────────────────────────────────────────
const CustomToolbar = ({ onNavigate, label }) => {
  return (
    <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
      {/* Navigation */}
            <h2 className="text-xl font-bold text-slate-800 tracking-tight">{label}</h2>

      <div className="flex items-center gap-2">
        <button
          onClick={() => onNavigate("PREV")}
          className="flex items-center justify-center w-9 h-9 rounded-xl border border-slate-200 bg-white text-slate-500 hover:bg-slate-50 hover:text-slate-700 hover:border-slate-300 transition-all duration-200 shadow-sm"
          aria-label="Previous month"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          onClick={() => onNavigate("TODAY")}
          className="px-4 h-9 rounded-xl border border-blue-200 bg-blue-50 text-blue-700 text-sm font-semibold hover:bg-blue-100 hover:border-blue-300 transition-all duration-200"
        >
          Today
        </button>
        <button
          onClick={() => onNavigate("NEXT")}
          className="flex items-center justify-center w-9 h-9 rounded-xl border border-slate-200 bg-white text-slate-500 hover:bg-slate-50 hover:text-slate-700 hover:border-slate-300 transition-all duration-200 shadow-sm"
          aria-label="Next month"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
      {/* Month / Year Label */}
      {/* <h2 className="text-xl font-bold text-slate-800 tracking-tight">{label}</h2> */}
      {/* View Badge */}
      {/* <div className="flex items-center gap-2">
        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-slate-100 text-slate-600 text-sm font-medium">
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
          </svg>
          Month View
        </span>
      </div> */}
      <div></div>
    </div>
  );
};
// ─── Legend config ────────────────────────────────────────────────────────────
const LEGEND = [
  { label: "Meeting / Event", color: "#04367b" },
  { label: "Design",          color: "#059669" },
  { label: "Conference",      color: "#dc2626" },
  { label: "Implementation",  color: "#d97706" },
  { label: "Leave",           color: "#ef4444" },
  { label: "Other",           color: "#7c3aed" },
];
// ─── Main Component ───────────────────────────────────────────────────────────
const BigCalendar = () => {
  let portNumber = localStorage.getItem("BondTimeportNoData");
  const storedUserDataArray =
    JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null;
  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0]?.cmpcode;
  }
  const [originalEventsArray, setOriginalEventsArray] = useState(null);
  const [allEvents, setAllEvents]                     = useState(null);
  const [events, setEvents]                           = useState();
  const [clickedDate, setClickedDate]                 = useState(null);
  const [clickedDateFormatted, setClickedDateFormatted] = useState(null);
  const [showJobCardPopUp, setShowJobCardPopUp]       = useState(false);
  const [showMoreModal, setShowMoreModal]             = useState(false);
  const [selectedEvent, setSelectedEvent]             = useState(null);
  const [isLoading, setIsLoading]                     = useState(false);
  const popupRef = useRef(null);
  // ── Scroll handler (unchanged logic) ────────────────────────────────────────
  useEffect(() => {
    const handleScroll = () => {
      if (selectedEvent && popupRef.current) {
        const updatedTop  = selectedEvent.y + window.scrollY;
        const updatedLeft = selectedEvent.x + window.scrollX;
        popupRef.current.style.top  = `${updatedTop}px`;
        popupRef.current.style.left = `${updatedLeft}px`;
        setSelectedEvent({ ...selectedEvent, x: updatedLeft, y: updatedTop });
      }
    };
    const scrollContainer = document.getElementsByClassName("NewDashBody")[0];
    scrollContainer?.addEventListener("scroll", handleScroll);
    return () => scrollContainer?.removeEventListener("scroll", handleScroll);
  }, [selectedEvent]);
  const today = new Date().toLocaleDateString("en-CA");
  // ── Fetch events (unchanged logic) ──────────────────────────────────────────
  const getAllEvents = () => {
    setIsLoading(true);
    const apiUrl = `${base_url}/api/CRMEventFilter/${companyCode}/ALL/-/-/-/-/2024-01-01/${today}/-/-`;
    axios
      .get(apiUrl)
      .then((res) => {
        setOriginalEventsArray(res.data);
        const newArrayForCalendar = res.data.map((item) => ({
          title:   item.event_name,
          start:   new Date(item.event_scheduledon),
          end:     new Date(item.event_scheduledon),
          color:   "#04367b",
          allDay:  false,
          eventId: item.event_id,
        }));
        setEvents(newArrayForCalendar);
      })
      .catch((err) => {})
      .finally(() => setIsLoading(false));
  };
  useEffect(() => {
    getAllEvents();
  }, []);
  // ── Event handlers (unchanged logic) ────────────────────────────────────────
  const handleSelectEvent = (event, e) => {
    console.log("date clicked event ", event);
    openShowMoreModal();
    setAllEvents([event]);
  };
  const handlePopupClose = () => {
    setSelectedEvent(null);
  };
  const closeJobCardModal        = () => setShowJobCardPopUp(false);
  const openJobCardModal         = () => setShowJobCardPopUp(true);
  const closeShowMoreEventsModal = () => setShowMoreModal(false);
  const openShowMoreModal        = () => setShowMoreModal(true);
  const onSelectEvent = (event) => {
    console.log("selected event", event.slots);
    openJobCardModal();
    const clickedDate          = event.slots[0];
    const clickedDateFormatted = dayjs(event.slots[0]).format("DD-MM-YYYY");
    setClickedDate(clickedDate);
    setClickedDateFormatted(clickedDateFormatted);
  };
  const clickedOnShowMore = (event) => {
    console.log("clickedOnShowMore", event);
    openShowMoreModal();
    setAllEvents(event);
  };
  const callRefreshEventList = () => {
    getAllEvents();
    closeJobCardModal();
  };
  useEffect(() => {
    console.log("clickedDateFormatted:", clickedDateFormatted);
  }, [clickedDateFormatted]);
  console.log("Eventss:", allEvents);
  // ── Event style getter (enhanced) ───────────────────────────────────────────
  const eventStyleGetter = (event) => ({
    style: {
      backgroundColor: event.color || "#04367b",
      color:           "white",
      border:          "none",
      borderRadius:    "6px",
      fontSize:        "12px",
      fontWeight:      "600",
      padding:         "2px 8px",
      boxShadow:       "0 1px 3px 0 rgba(0,0,0,0.15)",
      cursor:          "pointer",
      opacity:         1,
    },
  });
  // ── Derived stats ─────────────────────────────────────────────────────────────
  const totalEvents     = events?.length ?? 0;
  const thisMonth       = new Date().getMonth();
  const thisYear        = new Date().getFullYear();
  const eventsThisMonth = events?.filter(
    (e) =>
      new Date(e.start).getMonth() === thisMonth &&
      new Date(e.start).getFullYear() === thisYear
  ).length ?? 0;
  const upcomingEvents  = events?.filter((e) => new Date(e.start) >= new Date()).length ?? 0;
  // ── Render ───────────────────────────────────────────────────────────────────
  return (
    <div className="BigCalendarWrapper min-h-screen bg-slate-50 p-6 bg-red-200">
      {/* ── Page Header ───────────────────────────────────────────────────── */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 tracking-tight">Calendar</h1>
          <p className="text-sm text-slate-500 mt-0.5">
            Schedule and manage your team events &amp; meetings
          </p>
        </div>
        {/* <button
          onClick={openJobCardModal}
          className="inline-flex items-center gap-2 px-4 py-2.5 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white text-sm font-semibold rounded-xl shadow-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          New Event
        </button> */}
      </div>
      {/* ── Stats Row ─────────────────────────────────────────────────────── */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
        {[
          {
            label: "Total Events",
            value: isLoading ? "—" : totalEvents,
            iconColor: "text-blue-600",
            bgColor: "bg-blue-50",
            icon: (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            ),
          },
          {
            label: "This Month",
            value: isLoading ? "—" : eventsThisMonth,
            iconColor: "text-emerald-600",
            bgColor: "bg-emerald-50",
            icon: (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            ),
          },
          {
            label: "Upcoming",
            value: isLoading ? "—" : upcomingEvents,
            iconColor: "text-amber-600",
            bgColor: "bg-amber-50",
            icon: (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            ),
          },
          {
            label: "Today",
            value: new Date().toLocaleDateString("en-US", { month: "short", day: "numeric" }),
            iconColor: "text-violet-600",
            bgColor: "bg-violet-50",
            icon: (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
              </svg>
            ),
          },
        ].map(({ label, value, icon, iconColor, bgColor }) => (
          <div
            key={label}
            className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 flex items-center gap-3"
          >
            <div className={`${bgColor} ${iconColor} w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0`}>
              {icon}
            </div>
            <div>
              <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">{label}</p>
              <p className="text-lg font-bold text-slate-900 leading-tight">{value}</p>
            </div>
          </div>
        ))}
      </div>
      {/* ── Calendar Card ─────────────────────────────────────────────────── */}
      <div className="rounded-2xl border border-slate-200 shadow-sm overflow-hidden relative bg-white">
        {/* Loading overlay */}
        {isLoading && (
          <div className="absolute inset-0 z-10 bg-white/70 backdrop-blur-sm flex items-center justify-center rounded-2xl">
            <div className="flex flex-col items-center gap-3">
              <div
                className="w-8 h-8 rounded-full border-2 border-blue-200 border-t-blue-600 animate-spin"
              />
              <span className="text-sm font-medium text-slate-500">Loading events…</span>
            </div>
          </div>
        )}
        <Calendar
          selectable={true}
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          defaultView="month"
          views={["month"]}
          style={{ height: 620 }}
          eventPropGetter={eventStyleGetter}
          onSelectEvent={handleSelectEvent}
          onSelectSlot={onSelectEvent}
          onShowMore={clickedOnShowMore}
          components={{ toolbar: CustomToolbar }}
        />
      </div>
      {/* ── Legend ────────────────────────────────────────────────────────── */}
      {/* <div className="mt-4 flex flex-wrap items-center gap-4">
        <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider">
          Legend
        </span>
        {LEGEND.map(({ label, color }) => (
          <span key={label} className="inline-flex items-center gap-1.5">
            <span
              className="w-2.5 h-2.5 rounded-full flex-shrink-0"
              style={{ backgroundColor: color }}
            />
            <span className="text-xs text-slate-500 font-medium">{label}</span>
          </span>
        ))}
      </div> */}
      {/* ── Selected Event Popup (logic unchanged, redesigned UI) ─────────── */}
      {selectedEvent && (
        <div
          ref={popupRef}
          className="rbc-overlay"
          style={{ position: "absolute", top: "10%", left: "50%", transform: "translateX(-50%)", zIndex: 1000 }}
        >
          <div className="bg-white rounded-2xl shadow-xl border border-slate-200 p-5 min-w-[280px]">
            {/* Header */}
            <div className="flex items-start justify-between gap-3 mb-4">
              <div className="flex items-center gap-2.5">
                <span
                  className="w-3 h-3 rounded-full flex-shrink-0"
                  style={{ backgroundColor: selectedEvent.color }}
                />
                <h5 className="font-bold text-slate-900 text-base leading-tight">
                  {selectedEvent.title}
                </h5>
              </div>
              <button
                onClick={handlePopupClose}
                className="w-7 h-7 rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-150"
                aria-label="Close"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            {/* Employee badge (Leave only) */}
            {selectedEvent.title === "Leave" && (
              <div className="flex items-center gap-2 mb-4 p-2.5 bg-red-50 rounded-xl border border-red-100">
                <svg className="w-4 h-4 text-red-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <span className="text-sm font-semibold text-red-700">{selectedEvent.employee}</span>
              </div>
            )}
            {/* Dates */}
            <div className="space-y-3">
              {[
                { label: "Start", value: format(selectedEvent.start, "MMMM do yyyy, h:mm a") },
                { label: "End",   value: format(selectedEvent.end,   "MMMM do yyyy, h:mm a") },
              ].map(({ label, value }) => (
                <div key={label} className="flex items-center gap-2.5">
                  <svg className="w-4 h-4 text-slate-400 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <div>
                    <p className="text-xs font-medium text-slate-400 uppercase tracking-wide leading-none mb-0.5">
                      {label}
                    </p>
                    <p className="text-sm font-semibold text-slate-700">{value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {/* ── Modals (unchanged) ────────────────────────────────────────────── */}
      <EventCreationModal
        closeJobCardModal={closeJobCardModal}
        showJobCardPopUp={showJobCardPopUp}
        clickedDateFromCalendar={clickedDate}
        clickedDateFromCalendarFormatted={clickedDateFormatted}
        callRefreshEventList={callRefreshEventList}
      />
      <ShowMoreEventsModal
        closeShowMoreEventsModal={closeShowMoreEventsModal}
        showMoreModal={showMoreModal}
        allEventsArray={allEvents}
        eventOriginalArray={originalEventsArray}
      />
    </div>
  );
};
export default BigCalendar;